<input type="text" class="form-control" name="weight"
       [ngModel]="value"
       (ngModelChange)="onWeightChange($event)"
>
